import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styles';
import { Reject } from 'icons/Reject';
import { TSizeType } from 'interfaces';

type TRejectedBadgeProps = {
  size: TSizeType;
};

export const RejectedBadge: FC<TRejectedBadgeProps> = ({ size = 'medium' }) => {
  const { t } = useTranslation();
  return (
    <Styled.RejectBadgeWrapper $size={size} title={t('nft.rejected')}>
      {size === 'small' ? <Reject size={15} /> : t('nft.rejected')}
    </Styled.RejectBadgeWrapper>
  );
};
